/**
 * Kody instancji aplikacji
 *
 * @export
 * @enum {number}
 */
export enum ProcedureInstance {
  COFINANCING = 'dofinansowanie',
  DISTINCTIONS = 'wyroznienia',
  DUPLICATES = 'duplikaty',
  SCHOLARSHIPS = 'stypendia'
}
